import React from "react";
import { AndroidSec } from "./android";

export const Android = () => {
  return (
    <React.Fragment>
      <div className="android-main">
        <AndroidSec />
      </div>
    </React.Fragment>
  );
};
